import React from "react";

function About({ content }) {
  return (
    <section id="about" className="about-section">
      <div className="section-wrap">
        <div className="about-grid">
          <div className="about-text">
            <div className="section-eyebrow">{content?.eyebrow}</div>
            <h2 className="section-title">{content?.title}</h2>
            {(content?.paragraphs || []).map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <div className="about-metrics">
              {(content?.metrics || []).map((metric) => (
                <div className="metric-box" key={`${metric.value}-${metric.label}`}>
                  <div className={`metric-val${metric.accent ? " teal" : ""}`}>
                    {metric.value}
                  </div>
                  <div className="metric-lbl">{metric.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="about-visual">
            <div className="about-card-stack">
              <div className="about-card about-card-main">
                <h3>{content?.cards?.mainTitle}</h3>
                <p>{content?.cards?.mainText}</p>
              </div>
              <div className="about-card about-card-floating">
                <div className="float-num">{content?.cards?.floatingValue}</div>
                <p>{content?.cards?.floatingText}</p>
              </div>
              <div className="about-card about-card-cert">
                <div className="cert-label">{content?.cards?.certLabel}</div>
                <div className="cert-val">{content?.cards?.certValue}</div>
                <div className="cert-label about-cert-offset">
                  {content?.cards?.statusLabel}
                </div>
                <div className="cert-val cert-val-small teal-text">
                  {content?.cards?.statusValue}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
